module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-outright02.6409eb88.svg";